import { IconCreditCard, IconX } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { Button, Card, Grid, Group, TextInput } from '@mantine/core';
import paymentIcons from '../constants/paymentIcons';
import useFetch from '../helpers/useFetch';
import ErrorMessage from './ErrorMessage';
import ConfirmationModal from './Modals/ConfirmationModal';

const AccountPaymentMethod = ({ account }) => {
  const [payment, setPayment] = useState();
  const [error, setError] = useState();
  const [confirmCancelOpen, setConfirmCancelOpen] = useState(false);
  const fetch = useFetch();

  const fetchURL = `/api/admin/accounts/${account.id}/paymentMethod`;

  const addPayment = () => {
    fetch(`/api/admin/accounts/${account.id}/paymentMethod/authorization`, {
      method: 'POST',
      body: JSON.stringify({}),
    })
      .then(({ url }) => {
        window.location.replace(url);
      })
      .catch(setError);
  };

  useEffect(() => {
    fetch(fetchURL)
      .then(({ payment }) => {
        setPayment(payment);
      })
      .catch((error) => {
        setError(error);
      });
  }, [fetch, fetchURL]);

  const cancelPayment = (cb) => {
    fetch(`/api/admin/accounts/${account.id}/paymentMethod/cancel`, {
      method: 'DELETE',
    })
      .then(() => {
        if (typeof cb === 'function') {
          cb();
        }
        setPayment(null);
      })
      .catch(setError);
  };

  const cancelButton = (
    <Button color="red" onClick={() => setConfirmCancelOpen(true)}>
      <IconX size={16} /> Delete
    </Button>
  );

  return (
    <Grid>
      <ConfirmationModal
        show={confirmCancelOpen}
        close={() => setConfirmCancelOpen(false)}
        confirm={(cb) => cancelPayment(cb)}
        message="This action cannot be undone!"
      />

      <Grid.Col span={{ base: 12, md: 3 }}>Payment method</Grid.Col>
      <Grid.Col span={{ base: 12, md: 9 }}>
        {payment ? (
          <Card withBorder>
            <Grid mb="md">
              <Grid.Col span={{ base: 12, sm: 3 }} style={{ display: 'flex', alignItems: 'center' }}>
                <label>Card type:</label>
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 9 }}>
                {(() => {
                  const Icon = paymentIcons[payment.cardType]?.icon || paymentIcons.unknown.icon;
                  return <Icon size={32} />;
                })()}
              </Grid.Col>
            </Grid>

            <Grid mb="md">
              <Grid.Col span={{ base: 12, sm: 3 }} style={{ display: 'flex', alignItems: 'center' }}>
                <label>Card digits:</label>
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 9 }}>
                <TextInput
                  disabled
                  name="cardLastDigits"
                  value={`**** ${payment.cardLastDigits}`}
                />
              </Grid.Col>
            </Grid>

            <Grid mb="md">
              <Grid.Col span={{ base: 12, sm: 3 }} style={{ display: 'flex', alignItems: 'center' }}>
                <label>Expire Date:</label>
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 9 }}>
                <TextInput disabled name="cardExpireDate" value={payment.cardExpireDate} />
              </Grid.Col>
            </Grid>

            <Group justify="flex-end" mt="md">
              {cancelButton}
            </Group>
          </Card>
        ) : (
          <span>
            <Button onClick={addPayment}>
              <IconCreditCard size={16} /> Add new
            </Button>
          </span>
        )}
        <ErrorMessage message={error?.message} />
      </Grid.Col>
    </Grid>
  );
};

export default AccountPaymentMethod;
